/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useMemo } from 'react';

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';
import { jsx } from '@atlaskit/css';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
	ModalTransition,
} from '@atlaskit/modal-dialog';
import { ReactRenderer } from '@atlaskit/renderer';
import { encodeAdf } from '@atlassian/conversation-assistant-content-transformer/adf-encoder';

import { useDataSculptorModal } from '../../../../controllers/data-sculptor-modal/useDataSculptorModal';

import messages from './messages';

export const DataSculptorModal = (): JSX.Element => {
	const { formatMessage } = useIntl();
	const [{ isOpen, data }, { closeModal }] = useDataSculptorModal();

	const document = useMemo(() => {
		if (!data) {
			return null;
		}
		return encodeAdf(data);
	}, [data]);

	return (
		<ModalTransition>
			{isOpen && (
				<Modal shouldCloseOnEscapePress shouldCloseOnOverlayClick onClose={closeModal}>
					<ModalHeader hasCloseButton>
						<ModalTitle>{formatMessage(messages.modalTitle)}</ModalTitle>{' '}
					</ModalHeader>

					<ModalBody>
						{document ? (
							<ReactRenderer document={document} allowCopyToClipboard />
						) : (
							<div>{formatMessage(messages.noData)}</div>
						)}
					</ModalBody>

					<ModalFooter>
						<Button appearance="subtle" onClick={closeModal}>
							{formatMessage(messages.modalCancelButton)}
						</Button>
					</ModalFooter>
				</Modal>
			)}
		</ModalTransition>
	);
};
